export default function modal() {
  return {
    open: false,
    openModal() {
      this.open = true;
      document.body.style.overflowY = 'hidden';
    },
    closeModal() {
      this.open = false;
      document.body.style.overflowY = 'initial';
    },
    toggleModalOpen() {
      if (this.open) {
        this.closeModal();
      } else {
        this.openModal();
      }
    },
  };
}
